// State management
import { useAppSelector } from "../../../services/StoreHelper";

// Internal components
import EmailCard from "../EmailCard/EmailCard";

// Styles
import email_card_styles from "../EmailCard/email_card_styles";
import email_styles_2 from "./email_styles_2";

function EmailBody() {
  const { app_dimensions } = useAppSelector((state) => state.app);

  return (
    <div style={email_styles_2.container}>
      <EmailCard />
      <img
        src="/logo.svg"
        style={email_card_styles(app_dimensions).logo}
        width={92.8}
        height={16}
      />
    </div>
  );
}
export default EmailBody;